import axios from 'src/utils/axios';
import _ from 'lodash';

export const ADD_PENDING_MESSAGE = '@channelweb/addmessage';

export function addMessage(botId, userId, trheadId, payload) {
  const message = {
    pending: true,
    from: userId,
    thread_id: trheadId,
    type: payload.type,
    payload
  };
  const request = axios.post(`/messaging/channel-web/${botId}/webhook`, {
    messages: [message]
  });
  return dispatch => {
    request.then(response => {
      if (message.thread_id) {
        dispatch({
          type: ADD_PENDING_MESSAGE,
          payload: { message }
        });
      }
    });
  };
}
